var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sort"},_vm._l((_vm.sortList),function(item,index){return _c('a',{class:{ 'active': _vm.currentSort === item.sort },attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.doSort( item.sort )}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }